import { FunctionComponent } from "react";

import { faClock, faLock } from "@fortawesome/pro-regular-svg-icons";

import { format } from "date-fns";

import { Icon } from "@/components";

import { Companies } from "../schema/companies";

/**
 * The "Demo ends in" cell of the admin Companies table.
 *
 * Extracted from `CompaniesTable` unchanged (PREC-4093), to make room for the lifecycle columns
 * beside it without pushing that file past the 500-line gate. The `try/catch` around `format` is
 * kept: `demoEndsAt` is a raw API string and an unparseable one would otherwise throw inside the
 * table's render.
 */
export const DemoEndsCell: FunctionComponent<{ row: Companies }> = ({ row }) => {
	const demoEndsAt = row?.demoEndsAt ? new Date(row?.demoEndsAt) : null;

	let formattedDate = "";

	try {
		if (demoEndsAt) {
			formattedDate = format(demoEndsAt, "dd.MM.yyyy");
		}
	} catch (err) {
		console.error(err);
	}

	if (!row?.isDemo) {
		return <div />;
	}

	return (
		<div>
			<div className="flex flex-row items-center gap-2">
				{demoEndsAt && demoEndsAt > new Date() ? <Icon icon={faClock} /> : <Icon icon={faLock} />}
				{formattedDate && <>{formattedDate}</>}
			</div>
		</div>
	);
};
